// Hello.
//
// This is The Scripts used for Awesome Photography/Portfolio Template
//
//

import $ from 'jquery'
import { WOW } from 'wowjs'
import SmoothScroll from 'smooth-scroll'

function main() {

(function () {
   'use strict';

   //Page Loader
        //<![CDATA[
      $(window).load(function() { // makes sure the whole site is loaded
        $('#status').fadeOut(); // will first fade out the loading animation
        $('#preloader').delay(350).fadeOut('slow'); // will fade out the white DIV that covers the website.
        $('body').delay(350).css({'overflow':'visible'});

        // Internet Explorer and phones :
        // window.objectFitImages();

      });
      //]]>

  var div = document.createElement("div");
  div.innerHTML = "<!--[if lt IE 9]><i></i><![endif]-->";
  var isIeLessThan8 = (div.getElementsByTagName("i").length == 1);
  if (isIeLessThan8) {
    document.getElementsByTagName("body")[0].innerHTML = "<h1>Please visit us with Chrome or Firefox, or upgrade your browser.</h1>";
  }

  div.innerHTML = "<!--[if le IE 9]><i></i><![endif]-->";
  var isIeLessThan9 = (div.getElementsByTagName("i").length == 1);
  if (!isIeLessThan9) {
    // Wow animation
    var wow = new WOW();
    wow.init();
  }

    // // Smooth scroll
    var scroll = new SmoothScroll('a[href*="#"]');

    // jQuery for page scrolling feature - requires jQuery Easing plugin
      $(function() {
        $('a.page-scroll').bind('click', function(event) {
          var $anchor = $(this);
          $('html, body').stop().animate({
            scrollTop: $($anchor.attr('href')).offset().top - 70
            }, 900, 'easeInOutExpo');
          event.preventDefault();
        });
      });

    // Highlight the top nav as scrolling occurs
      $('body').scrollspy({
          target: '.navbar-fixed-top' ,
          offset: 75
      });

}());

}
main();

